import ExternalApiRequest from "services/externalApiRequest";

const guestLoginConnector = () => {
    const options = {
        api: "guestLogin",
    }
    return ExternalApiRequest(options);
};

export default guestLoginConnector;
